import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { enableWebPush } from "@/lib/push";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

let clickAudio = null;
export function playClick() {
  if (localStorage.getItem("sound") !== "on") return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!clickAudio) clickAudio = new AC();
    const ctx = clickAudio;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(620, ctx.currentTime);
    o.frequency.exponentialRampToValueAtTime(180, ctx.currentTime + 0.09);
    g.gain.setValueAtTime(0.06, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.12);
    o.connect(g); g.connect(ctx.destination);
    o.start(); o.stop(ctx.currentTime + 0.13);
  } catch (e) {}
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      // Keep authenticated browsers subscribed for company-wide push notifications.
      enableWebPush().catch(() => {});
    } catch {
      localStorage.removeItem("token");
      setUser(false);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) {
      localStorage.setItem("token", data.token);
      setUser(data.user);
      enableWebPush().catch(() => {});
    }
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) {
      localStorage.setItem("token", data.token);
      setUser(data.user);
      enableWebPush().catch(() => {});
    }
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: load }}>
      {children}
    </AuthCtx.Provider>
  );
}
